import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
export const MobileExternalViewerSubdomainNotAllowed = _ref => {
  let {
    datahook
  } = _ref;
  const {
    t
  } = DomainSearchGateModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook
  }, t('domains_search_gate.connect.mobile.vibe.subdomain.block'));
};
//# sourceMappingURL=MobileExternalViewerSubdomainNotAllowed.js.map